import React from 'react';
import { useTranslation } from 'react-i18next';
import { DetailsRow } from '@/components/PreschoolEvaluationModal/DetailsRow';
import type { PreschoolEvaluationResponse } from '@/types/preschool';

interface Props {
  evaluation: PreschoolEvaluationResponse;
}

export const StudentDetailsCard: React.FC<Props> = ({ evaluation }) => {
  const { t } = useTranslation();

  const { schoolName, studentFullName, studentIIN, authorDescription } =
    evaluation;

  return (
    <div className="flex flex-col gap-3 rounded-xl border border-transparent bg-card px-4 py-3 shadow-card contrast:border-border">
      {schoolName && (
        <DetailsRow
          label={t('preschoolEvaluation.institution')}
          value={schoolName}
        />
      )}
      {studentFullName && (
        <DetailsRow
          label={t('preschoolEvaluation.student')}
          value={studentFullName}
        />
      )}
      {studentIIN && (
        <DetailsRow
          label={t('preschoolEvaluation.personalCode')}
          value={studentIIN}
        />
      )}
      {authorDescription && (
        <DetailsRow
          label={t('preschoolEvaluation.evaluator')}
          value={authorDescription}
        />
      )}
    </div>
  );
};
